/*
 * Key Codes (events)
 */

export default {
    SPACE: 32,
    BACKSPACE: 8,
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PAGEUP: 33,
    PAGEDOWN: 34,
    HOME: 36,
    END: 35,
    TAB: 9,
    DELETE: 46,
    INSERT: 45
};
